import { t } from '@lingui/macro'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { Card, CardActions, CardContent, Grid, IconButton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { FunctionComponent, MouseEventHandler } from 'react'
import { CohortListItem } from '../../state'
import { CohortDashboardCohortCardDetails } from './CohortDashboardCohortCardDetails'
import { CohortListItemToTitle } from './DashboardCohortCard'

export interface CohortDashboardCohortCardProps {
    cohort?: CohortListItem
    onSettingsGearClick?: MouseEventHandler<HTMLButtonElement> | undefined
    actions?: JSX.Element[]
    hidDetails?: boolean
    excludeTitleRowFromCard?: boolean
    showDescription?: boolean
    sizeLoading?: boolean
    onDescriptionChange?: (value: string) => void
}

/**
 * A card that summarizes a single cohort.
 */
export const CohortDashboardCohortCard: FunctionComponent<CohortDashboardCohortCardProps> = ({
    cohort,
    onSettingsGearClick,
    actions,
    hidDetails,
    excludeTitleRowFromCard,
    showDescription,
    onDescriptionChange,
    sizeLoading
}) => {
    const cardTitleRow = (
        <Grid container spacing={0} wrap='nowrap'>
            {cohort && (
                <Grid item xs id={`cohort-grid-item-gear-${cohort.id}`} sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Typography
                        sx={{
                            fontWeight: '500',
                            fontSize: '25px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            color: '#012D72'
                        }}
                    >
                        <CohortListItemToTitle cohort={cohort} />
                        {onSettingsGearClick && (
                            <IconButton
                                color='primary'
                                aria-label={t`Edit`}
                                onClick={onSettingsGearClick}
                                sx={{ margin: '5px', borderRadius: '2px', color: '#575A5C' }}
                            >
                                <SettingsOutlinedIcon sx={{ height: '25px', width: '25px' }} />
                            </IconButton>
                        )}
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            color: '#575A5C'
                        }}
                    >
                        {cohort.description}
                    </Typography>
                </Grid>
            )}
            {cohort && (
                <Grid item xs='auto' id={`cohort-grid-item-actions-${cohort.id}`} sx={{ flexShrink: 0 }}>
                    <CardActions
                        disableSpacing
                        sx={{
                            justifyContent: 'flex-end',
                            minHeight: 40,
                            paddingRight: '6px',
                            overflow: 'visible',
                            flexWrap: 'wrap'
                        }}
                    >
                        {actions?.map((action, index) => {
                            return action && <Box key={index}>{action}</Box>
                        })}
                    </CardActions>
                </Grid>
            )}
        </Grid>
    )

    return (
        <Box>
            {cohort && excludeTitleRowFromCard && <Box sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '10px' }}>{cardTitleRow}</Box>}
            {cohort && !hidDetails && (
                <Card
                    id={`cohort-dash-card-grid-item-card-${cohort.id}`}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        borderTopRightRadius: 2,
                        borderTopLeftRadius: 2,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        color: '#575A5C',
                        paddingRight: '10px',
                        paddingLeft: '10px',
                        overflow: 'visible'
                    }}
                >
                    {!excludeTitleRowFromCard && <CardContent sx={{ paddingRight: '6px' }}>{cardTitleRow}</CardContent>}
                    {/* {showDescription && onDescriptionChange && (
                        <EditableParagraph
                            tooltip={t`Click to edit description`}
                            sx={{
                                alignSelf: 'flex-start',
                                marginLeft: 0
                            }}
                            text={cohort.description}
                            editable={!cohort.isSystem}
                            onSave={onDescriptionChange}
                        />
                    )}
                    {showDescription && cohort.description && !onDescriptionChange && (
                        <EditableParagraph
                            sx={{
                                alignSelf: 'flex-start',
                                marginLeft: 0
                            }}
                            text={cohort.description}
                            editable={false}
                        />
                    )} */}
                    {cohort && <CohortDashboardCohortCardDetails cohort={cohort} />}
                </Card>
            )}
        </Box>
    )
}
